import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getRequestersFromExportRequests } from 'services/results'
import { ResultsQueryKeys } from 'services/results/queryKeys'
import type { GetRequestersFromExportRequestsResponse } from 'services/results/types'
import { ApiErrorResponse } from 'services/types'

export const useGetRequestersFromExportRequests = (
  options?: Omit<UseQueryOptions<GetRequestersFromExportRequestsResponse, ApiErrorResponse>, 'queryKey'>
) => {
  return useQuery<GetRequestersFromExportRequestsResponse, ApiErrorResponse>({
    queryKey: ResultsQueryKeys.RequestersFromExportRequests(),
    queryFn: ({ signal }) => getRequestersFromExportRequests({ signal }),
    ...options
  })
}
